import { useEffect, useState } from 'react';
import { BASE_URL } from './constant'; // Adjust path if needed
import './FreshersRegistration.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function FreshersRegistration() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [preferDays, setPreferDays] = useState([]);

  useEffect(() => {
    fetch(`${BASE_URL}/selection-settings`)
      .then((res) => res.json())
      .then((data) => {
        if (data.status === 'Success' && data.settings?.days) {
          setPreferDays(data.settings.days);
        }
      })
      .catch(() => {
        // Form still works with empty options until settings load
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    console.log('Submitting Form...');

    // Collect form data
    const formData = new FormData(e.target);

    // Prepare JSON data for /save endpoint
    const jsonData = {
      name: formData.get('name'),
      rollno: formData.get('rollno'),
      email: formData.get('email'),
      hall: formData.get('hall'),
      contact: formData.get('contact'),
      portfolio: formData.get('portfolio'),
      preferDay: formData.get('preferDay'),
      involvement: formData.get('involvement'),
      hometown: formData.get('hometown'),
      whyRCA: formData.get('whyRCA'),
    };

    // Send data to /save endpoint
    fetch(`${BASE_URL}/save`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jsonData)
    })
      .then(response => response.json())
      .then((saveRes) => {
        // Handle /save endpoint response
        if (saveRes.status !== "Success") {
          // If there are field errors, show them in the toast
          if (saveRes.fields && typeof saveRes.fields === 'object') {
            const fieldMessages = Object.entries(saveRes.fields)
              .map(([field, msg]) => `${field}: ${msg}`)
              .join('\n');
            throw new Error(`${saveRes.message}\n${fieldMessages}`);
          }
          throw new Error(saveRes.message || 'Save Endpoint Error');
        }
        toast.success('Thank you! Your form is submitted successfully.', {
          position: "top-center",
          autoClose: 3000,
          onClose: () => window.location.href = '/'
        });
        setIsSubmitting(false);
      })
      .catch((error) => {
        console.error('Error! ', error.message);
        toast.error(error.message, {
          position: "top-center",
          autoClose: 5000,
          style: { whiteSpace: 'pre-line' }
        });
        setIsSubmitting(false);
      });
  };


  return (
    <>
      <ToastContainer />
      <div className="BODY">
        <div className="back-color">
          <div className="full-screen">
            <div className="card">
              <div className="main-form">
                <div className="left-part">
                  <div>
                    {/* Registration Form */}
                    <form onSubmit={handleSubmit}>

                      <h3 className="main-heading">WELCOME FRESHERS!</h3>

                      {/* Name */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="name" className="our-q">Name *</label>
                          <input type="text" className="ans" name="name" id="name" placeholder="Your Full Name" required />
                        </div>
                      </div>

                      {/* Roll Number */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="rollNo" className="our-q">Roll Number *</label>
                          <input type="text" className="ans" name="rollno" id="rollNo" placeholder="Your Roll.No." required />
                        </div>
                      </div>

                      {/* Email */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="email" className="our-q">Email *</label>
                          <input type="text" className="ans" name="email" id="email" placeholder="Your email" required />
                        </div>
                      </div>

                      {/* Hall */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="hall" className="our-q">Hall *</label>
                          <select className="ans" name="hall" id="hall" required>
                            <option value="">Choose Your Hall</option>
                            <option value="LBS">LBS</option>
                            <option value="SNVH_IGH">SNVH IGH</option>
                          </select>
                        </div>
                      </div>

                      {/* Phone */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="phone" className="our-q">Phone *</label>
                          <input type="tel" className="ans" name="contact" id="phone" placeholder="Enter Your Phone No." required />
                        </div>
                      </div>

                      {/* Portfolio */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="portfolio" className="our-q">Portfolio *</label>
                          <select className="ans" name="portfolio" id="portfolio" required>
                            <option value="">Select</option>
                            <option value="Event Management">Event Management</option>
                            <option value="Web Development">Web Development</option>
                            <option value="Design">Design</option>
                          </select>
                        </div>
                      </div>

                      {/* Time Slots */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="timeSlots" className="our-q">Preferred Date *</label>
                          <select className="ans" name="preferDay" id="timeSlots" required>
                            <option value="">Select</option>
                            {preferDays.map((day) => (
                              <option key={day.optionValue} value={day.optionValue}>
                                {day.optionLabel}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Other Involvements */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="otherInvolvements" className="our-q">Other Involvements *</label>
                          <input type="text" className="ans" name="involvement" id="otherInvolvements" 
                          placeholder="Your Other Involvements" required />
                        </div>
                      </div>

                      {/* City */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="city" className="our-q">Hometown *</label>
                          <input type="text" className="ans" name="hometown" id="city" placeholder="Your Hometown" required />
                        </div>
                      </div>

                      {/* Why Join RCA */}
                      <div className="line">
                        <div className="details">
                          <label htmlFor="whyJoin" className="our-q">Why do you want to join RCA ? *</label>
                          <input type="text" className="ans" name="whyRCA" id="whyJoin"
                            placeholder="Why do you want to join RCA ?" required />
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="btn-box">
                        <button type="submit" disabled={isSubmitting} id="submit" className="submit-btn">
                        {isSubmitting ? "Please Wait..." : "Register"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>

                {/* Right-side Contact Info */}
                <div className="right-part">
                  <div className="contact-inf">
                    <img src="/img/FreshersRegistration/rcaglow.png" className="rca-logo" alt="..." />
                    <br /><br /><br />
                    <h3 className="contact">Contact Information</h3>
                    <p className="rca-name">Rajasthan Cultural Association IIT Kharagpur</p>
                    <ul className="ul11">
                      <li className="dot">IIT Kharagpur West Bengal 721302</li>
                      <li className="dot">+91-7898313113</li>
                      <li className="dot">rca.iitkgp@gmail.com</li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FreshersRegistration;